import { render, staticRenderFns } from "./JdsTableHeading.vue?vue&type=template&id=110c40b6&scoped=true&"
import script from "./JdsTableHeading.vue?vue&type=script&lang=ts&"
export * from "./JdsTableHeading.vue?vue&type=script&lang=ts&"
import style0 from "./JdsTableHeading.vue?vue&type=style&index=0&id=110c40b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110c40b6",
  null
  
)

export default component.exports